import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { list, reset, filter, sort } from '../../actions/LiveInterviewCandidateInvitation/list';
import {handleListUpdate, pagination, renderLinks} from "../../utils/entityList";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Moment from 'react-moment';
import filtersStorage from '../../utils/filtersStorage';
import FilterForm from "./FilterForm";
import {SortableTableCells} from "../../utils/filterForm";
import TableFooter from "@material-ui/core/TableFooter";
import {getRoutePage} from "../../utils/routes";
import DateTimeWithTimezone from "../DateTime/DateTimeWithTimezone";

class LiveInterviewCandidateInvitationList extends Component {
  static propTypes = {
    retrieved: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    list: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    filter: PropTypes.func.isRequired,
    filtersData: PropTypes.object,
    sort: PropTypes.func.isRequired,
    sortData: PropTypes.object,
  };

  componentDidMount() {
    const storageName = 'company_live_interview_candidate_invitation';
    const filters = filtersStorage.get(storageName, null);
    const sort = filtersStorage.getSort(storageName);
    if (filters !== null || sort !== null) {
      this.props.filter(filters);
      this.props.sort(sort);
    } else {
      handleListUpdate('live_interview_candidate_invitations', this.props);
    }
  }

  componentDidUpdate(prevProps) {
    handleListUpdate('live_interview_candidate_invitations', this.props, prevProps);
  }

  componentWillUnmount() {
    this.props.reset();
  }

  render() {
    return (
      <div>

        {this.props.loading && (
          <div className="alert alert-info">Loading...</div>
        )}
        {this.props.error && (
          <div className="alert alert-danger">{this.props.error}</div>
        )}
        <FilterForm
          initialValues={this.props.filtersData}
          onSubmit={this.props.filter}
          resetFilter={this.props.filterReset}
          parentLoading={this.props.loading}
        />

        <div style={{'overflowX': 'auto'}}>
          <Table className="table table-responsive table-striped table-hover one-way-interview mb-0">
            <TableHead>
              <TableRow>
                <SortableTableCells sort={this.props.sort} sortData={this.props.sortData} fields={{
                  'id': 'ID',
                  'firstName': 'Candidate',
                  'liveInterview.title': 'Live Interview',
                  'liveInterview.job.title': 'Job',
                }}/>
                <TableCell>Status</TableCell>
                <SortableTableCells sort={this.props.sort} sortData={this.props.sortData} fields={{
                  'createdAt': 'Created At',
                  'liveInterview.scheduledStartTime': 'Scheduled Time',
                }}/>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.retrieved &&
                this.props.retrieved['hydra:member'].map(item => (
                  <TableRow key={item['@id']}>
                    <TableCell scope="row" className="align-middle">
                      {item['id']}
                    </TableCell>
                    <TableCell className="align-middle">
                      {item.companyCandidate ? (renderLinks('candidates', item.companyCandidate, (companyCandidate) => {
                          return `${item['fullName']}`
                        })
                      ) : (`${item['fullName']}`)}
                    </TableCell>
                    <TableCell className="align-middle">
                      {item.liveInterview.completedAt ? (
                        renderLinks('live-interviews', item['liveInterview'], liveInterview => liveInterview.title)
                      ): (
                        renderLinks('live-interview-schedules', item['liveInterview'], liveInterview => liveInterview.title)
                      )}
                    </TableCell>
                    <TableCell className="align-middle">
                      {renderLinks('jobs', item.liveInterview.job, job => job.title)}
                    </TableCell>
                    <TableCell className="align-middle" style={{textTransform: 'capitalize'}}>{item["completionStatus"]}</TableCell>
                    <TableCell className="align-middle"><Moment format={Moment.timeFormat}>{item['createdAt']}</Moment></TableCell>
                    <TableCell className="align-middle">
                      <DateTimeWithTimezone time={item.liveInterview.scheduledStartTime} timezone={item.liveInterview.timezone} />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>

        <Table className="table table-responsive no-border">
          <TableFooter>
            <TableRow>
              {pagination(this.props.retrieved, getRoutePage(this.props.match))}
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    retrieved,
    loading,
    error,
    filtersData,
    sortData,
  } = state.liveInterviewCandidateInvitation.list;
  return { retrieved, loading, error, filtersData, sortData };
};

const mapDispatchToProps = dispatch => ({
  list: page => dispatch(list(page)),
  reset: () => dispatch(reset()),
  filter: (filtersData) => dispatch(filter(filtersData)),
  filterReset: () => dispatch(filter(null)),
  sort: (sortData) => dispatch(sort(sortData)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveInterviewCandidateInvitationList);
